import axios from 'axios';
import store from '@/store'
import { Toast } from 'vant'
import { getToken } from '@/utils/token'
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASEURL,
  timeout: 10000,
  withCredentials:false
});
instance.interceptors.request.use(function (config) {
  if(getToken() && store.state.user.userInfo.userId){
    config.headers.token = getToken()
  }
  config.headers['Access-Control-Allow-Origin'] = "*"
  if (config.method=='get') { //判断get请求
    config.params  =  config.params || {};
    config.params.t = Date.parse(new Date())/1000; //添加时间戳
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});
instance.interceptors.response.use(function (response) {
  //数据统一处理
  const res = response.data
  if (response.data instanceof ArrayBuffer) {
    return response
  }
  if (res.code != '200') {
    Toast.fail(res.msg || '请求失败');
    return res ? res : {};
  }else{
    return res
  }
}, function (error) {
  return error;
});

export default instance